











































































































































































































































































































import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";
import { Component, Prop, Vue } from "vue-property-decorator";
import { marketFunnelApi } from "@/api/statistics";
import { dateFormat, getCurrentMonth } from "@/utils/timeFormat";
import comprehensiveTable from "./comprehensive.vue";
import appearTable from "./appear.vue";
import channelTable from "./channel.vue";
import courseTable from "./course.vue";
import { roundNumbers } from "@/utils/roundNumbers";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
@Component({
  components: {
    comprehensiveTable,
    appearTable,
    channelTable,
    courseTable,
    commonStaffPullDown,
  },
})
export default class extends Vue {
  searchInfo: any = {
    enterDate: [],
    query_time: "",
  };
  dataList: any = [];
  searchData = {};
  checkTabs: number = 1;
  start: string = "";
  end: string = "";
  studentAppearList: any[] = [];
  sourceList: any[] = [];
  pictureData: any = {}; // 漏斗图表
  executeTimeOptions = {
    disabledDate: (time: any) => {
      if (this.searchInfo.start_time && this.searchInfo.end_time) {
        return (
          time.getTime() <
            new Date(this.searchInfo.start_time).getTime() -
              1 * 24 * 60 * 60 * 1000 || time.getTime() > new Date().getTime()
        );
        //这里是查询时间的选择不可以小于录入时间的开始时间和今天时间
      }
    },
  };
  choiceDate0: any = "";
  enterDateOptions = {
    // 设置不能选择的日期
    onPick: ({ maxDate, minDate }: any) => {
      this.choiceDate0 = minDate.getTime();
      if (maxDate) {
        this.choiceDate0 = "";
      }
    },
    disabledDate: (time: any) => {
      const choiceDateTime = new Date(this.choiceDate0).getTime();
      const minTime = new Date(choiceDateTime).setMonth(
        new Date(choiceDateTime).getMonth() - 11
      );
      const maxTime = new Date(choiceDateTime).setMonth(
        new Date(choiceDateTime).getMonth() + 11
      );
      const min = minTime;
      const newDate =
        new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        1;
      const max = newDate < maxTime ? newDate : maxTime;
      //如果已经选中一个日期 则 返回 该日期前后一个月时间可选
      if (this.choiceDate0) {
        return time.getTime() < min || time.getTime() > max;
      }
      //若一个日期也没选中 则 返回 当前日期以前日期可选
      return time.getTime() > newDate;
    },
  };
  created() {
    getStudentAppearListApi({
      page: 1,
      page_size: 500,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.studentAppearList = res.data.list;
      }
    });
    sourceTypeSelectListApi().then((res: any) => {
      if (res.error_code === 0) {
        this.sourceList = res.data.list;
      }
    });
    this.getMonthTime();
    this.searchInfo.query_time = dateFormat("YYYY-mm-dd", new Date());
  }
  async beforeMount() {
    await this.getList({
      start_time: this.searchInfo.start_time,
      end_time: this.searchInfo.end_time,
    });
  }
  getList(time: { start_time: string; end_time: string }) {
    marketFunnelApi({
      start_time: time.start_time,
      end_time: time.end_time,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.dataList = [];
        const d = res.data;
        d.roster_visit_nuo_transform = roundNumbers(
          d.roster_visit_nuo_transform
        );
        d.visit_nuo_transform = roundNumbers(d.visit_nuo_transform);
        d.visit_transform = roundNumbers(d.visit_transform);
        this.pictureData = d;
        const stageArr: any = {
          title: "阶段数据",
          popover3: "诺访: 诺访状态的意向学员，按名单人数去重统计；",
          popover4: "已到访: 已到访状态的意向学员，按名单人数去重统计；",
          popover6: "已转化：已转化状态的意向学员，按名单人数去重统计；",
          popover7: "订单金额：已转化为在读学员的有效订单金额统计；",
          n: 2,
          arr: [
            {
              name: "诺访",
              num: d.committed_to_visit_num,
              route_name: "follow",
              key: 3,
            },
            {
              name: "已到访",
              num: d.visited_num,
              route_name: "follow",
              key: 4,
            },
            {
              name: "已转化",
              num: d.transformed_num,
              route_name: "follow",
              key: 6,
            },
            {
              name: "订单金额",
              num: roundNumbers(d.order_amount),
              route_name: "",
              key: "",
            },
          ],
        };
        const transformArr = {
          title: "转化率",
          popover8: "名单诺访率 = 诺访数 / 名单数 * 100%；",
          popover9: "诺访到访率 = 已到访数 / 诺访数 * 100%；",
          popover10: "到访转化率 = 已转化数 / 已到访数 * 100%；",
          popover11: "名单转化率 = 已转化数 / 名单数 * 100%",
          n: 3,
          arr: [
            {
              name: "名单诺访率",
              num: roundNumbers(d.roster_visit_nuo_transform) + "%",
              route_name: "",
              key: "",
            },
            {
              name: "诺访到访率",
              num: roundNumbers(d.visit_nuo_transform) + "%",
              route_name: "",
              key: "",
            },
            {
              name: "到访转化率",
              num: roundNumbers(d.visit_transform) + "%",
              route_name: "",
              key: "",
            },
            {
              name: "名单转化率",
              num: roundNumbers(d.roster_transform) + "%",
              route_name: "",
              key: "",
            },
          ],
        };
        this.dataList.push(stageArr, transformArr);
      }
    });
  }
  getChartData() {
    const monthStartArr = getCurrentMonth(this.searchInfo.enterDate[0]);
    const monthEndArr = getCurrentMonth(this.searchInfo.enterDate[1]);
    const start = dateFormat("YYYY-mm-dd", monthStartArr[0]);
    const end = dateFormat("YYYY-mm-dd", monthEndArr[1]);
    this.searchInfo.start_time = start;
    this.searchInfo.end_time = end;
    this.getList({
      start_time: this.searchInfo.start_time,
      end_time: this.searchInfo.end_time,
    });
    this.searchData = this.searchInfo;
  }
  handleSearch() {
    this.searchData = this.searchInfo;
  }
  getMonthTime() {
    const now = new Date();
    const monthArr = getCurrentMonth(now.getTime());
    this.start = dateFormat("YYYY-mm-dd", monthArr[0]);
    this.end = dateFormat("YYYY-mm-dd", monthArr[1]);
    this.searchInfo.enterDate[0] = this.start.slice(0, 7);
    this.searchInfo.enterDate[1] = this.end.slice(0, 7);
    this.getChartData();
  }
}
